import React from 'react';
import './RawIntelligence.css';

function RawIntelligence() {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Raw Intelligence</h1>
        <p className="lead">Data exploration and raw intelligence analysis</p>
      </div>
      
      <div className="content-section">
        <div className="row">
          <div className="col-md-4">
            <div className="card feature-card">
              <div className="card-body">
                <h3>Data Sources</h3>
                <p>Connect and explore raw data sources</p>
                <i className="bi bi-database feature-icon"></i>
              </div>
            </div>
          </div>
          
          <div className="col-md-4">
            <div className="card feature-card">
              <div className="card-body">
                <h3>Data Mining</h3>
                <p>Extract patterns and insights from raw data</p>
                <i className="bi bi-gear-wide-connected feature-icon"></i>
              </div>
            </div>
          </div>
          
          <div className="col-md-4">
            <div className="card feature-card">
              <div className="card-body">
                <h3>Data Quality</h3>
                <p>Monitor and maintain data quality standards</p>
                <i className="bi bi-check-circle feature-icon"></i>
              </div>
            </div>
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <h4>Active Data Sources</h4>
                <div className="data-sources-grid">
                  <div className="source-item">
                    <i className="bi bi-cloud text-primary"></i>
                    <div className="source-info">
                      <h5>Cloud Storage</h5>
                      <div className="source-metrics">
                        <span>Status: <span className="badge bg-success">Active</span></span>
                        <span>Files: 2,345</span>
                      </div>
                    </div>
                  </div>
                  <div className="source-item">
                    <i className="bi bi-table text-info"></i>
                    <div className="source-info">
                      <h5>Database Records</h5>
                      <div className="source-metrics">
                        <span>Status: <span className="badge bg-success">Active</span></span>
                        <span>Records: 1.2M</span>
                      </div>
                    </div>
                  </div>
                  <div className="source-item">
                    <i className="bi bi-file-earmark-text text-warning"></i>
                    <div className="source-info">
                      <h5>Document Repository</h5>
                      <div className="source-metrics">
                        <span>Status: <span className="badge bg-success">Active</span></span>
                        <span>Documents: 5,678</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RawIntelligence;
